import { render } from "./OkrFilterSaverForm.vue?vue&type=template&id=f89a2766&scoped=true"
import script from "./OkrFilterSaverForm.vue?vue&type=script&lang=js"
export * from "./OkrFilterSaverForm.vue?vue&type=script&lang=js"

import "./OkrFilterSaverForm.vue?vue&type=style&index=0&id=f89a2766&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89a2766"]])

export default __exports__